import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

function PublicRoute(props) {
  const {Component} = props;
  const navigate = useNavigate();
  useEffect(()=>{
    let login = localStorage.getItem("token");
    if(login){
      navigate("/dashboard")

    }

  },[])

    return (
      <>
      <Component/>
      </>
    )
    
  }
export default PublicRoute;